import {SelectItem} from '@/components/ui/select-atoms/SelectAtoms'
import styled, {css} from 'styled-components'

export const StyledTriggerLabel = styled.span(
    ({theme: {palette}}) => css`
        max-width: 120px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        & span {
            color: ${palette.neutral['500']};
        }
    `
)

export const StyledItem = styled(SelectItem)(
    ({theme: {spacing}}) => css`
        & .actions-button {
            display: none;
            margin-right: 1px; /* to avoid shadow cut */
        }
        &:hover {
            & .visibility-icon {
                display: none;
            }
            & .actions-button {
                display: flex;
            }
        }

        & > div {
            width: 100%;
            height: 26px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: ${spacing * 2}px;
            overflow-x: hidden;
            & span {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }
    `
)

export const StyledSaveWrapper = styled.div`
    display: flex;
    & *:first-child {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
    }
    & *:not(:first-child) {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
    }
`
